/**
 * One app-wide live-read interest: refresh cues work for confined viewers and
 * continue independently of analytics. AppLayout owns the socket lifecycle;
 * acquiring interest before connection lets its registry replay the join.
 */

import { useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { useIsAuthenticated } from '@azure/msal-react'
import { webSocketService } from '@/services/simpleWebSocket'
import { HOME_LIVE_QUERY_KEY } from '@/hooks/useHomeLive'

export function useHomeLiveRealtime(): void {
  const queryClient = useQueryClient()
  const isAuthenticated = useIsAuthenticated()

  useEffect(() => {
    if (!isAuthenticated) return

    return webSocketService.subscribeToHomeLive(() => {
      void queryClient.invalidateQueries(
        { queryKey: HOME_LIVE_QUERY_KEY },
        { cancelRefetch: false }
      )
    })
  }, [queryClient, isAuthenticated])
}
